/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadTaskWorkflowItem } from './LeadTaskWorkflowItem';
import {
    LeadTaskWorkflowItemFromJSON,
    LeadTaskWorkflowItemFromJSONTyped,
    LeadTaskWorkflowItemToJSON,
    LeadTaskWorkflowItemToJSONTyped,
} from './LeadTaskWorkflowItem';

/**
 * 
 * @export
 * @interface FindAllLeadTaskWorkflowItems200Response
 */
export interface FindAllLeadTaskWorkflowItems200Response {
    /**
     * 
     */
    data: Array<LeadTaskWorkflowItem>;
}

/**
 * Check if a given object implements the FindAllLeadTaskWorkflowItems200Response interface.
 */
export function instanceOfFindAllLeadTaskWorkflowItems200Response(value: object): value is FindAllLeadTaskWorkflowItems200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function FindAllLeadTaskWorkflowItems200ResponseFromJSON(json: any): FindAllLeadTaskWorkflowItems200Response {
    return FindAllLeadTaskWorkflowItems200ResponseFromJSONTyped(json, false);
}

export function FindAllLeadTaskWorkflowItems200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllLeadTaskWorkflowItems200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(LeadTaskWorkflowItemFromJSON)),
    };
}

export function FindAllLeadTaskWorkflowItems200ResponseToJSON(json: any): FindAllLeadTaskWorkflowItems200Response {
    return FindAllLeadTaskWorkflowItems200ResponseToJSONTyped(json, false);
}

export function FindAllLeadTaskWorkflowItems200ResponseToJSONTyped(value?: FindAllLeadTaskWorkflowItems200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(LeadTaskWorkflowItemToJSON)),
    };
}

